import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { RestUrlsConfig } from '@signature-it/ngx-generic/config';
import { FakeloaderComponent } from '@signature-it/ngx-generic/components/fakeloader';
import { EventBusService } from '@signature-it/ngx-generic/services';
import { EventData, EventName } from '@signature-it/ngx-generic/classes';

@Injectable()
export class CustomTranslateLoader implements TranslateLoader  {
    constructor(
        private httpClient: HttpClient,
        private restUrls: RestUrlsConfig,
        private eventBusService: EventBusService) {}
    getTranslation(lang: string): Observable<any> {
        FakeloaderComponent.forceLoading = true;
        FakeloaderComponent.start();
        const apiAddress = `${this.restUrls.appURL}/public/language/${lang}/dictionary.json?type=ui`;
        return this.httpClient.get(apiAddress)
            .pipe(tap(() => {
                    FakeloaderComponent.forceLoading = false;
                    FakeloaderComponent.stop();
                    this.eventBusService.emit(new EventData(EventName.DICTIONARY_REQUEST_COMPLETED, true));
                }, () =>
                    this.httpClient.get(`/assets/i18n/en.json`))
            );
    }
}
